import type { Uuid } from '@common/types';
import type { DenormalizedGridEntity } from '@web/types';
import type { GridsState } from './grids.reducer';
import type { PageStructureState } from '../page-structure-feature.reducer';

import { createSelector } from '@ngrx/store';
import { denormalize } from 'normalizr';

import { selectWidgetsEntities } from '@web/store/page-structure/widgets/widgets.selectors';
import { gridSchema } from '@web/store/page-structure/page-structure/mockStructureData';

import { GRIDS_FEATURE_KEY, gridsAdapter } from './grids.reducer';
import { pageStructureState } from '../page-structure-state.selectors';

const { selectAll, selectEntities, selectIds } = gridsAdapter.getSelectors();

// Lookup the 'Grids' feature state managed by NgRx
export const selectGridsState = createSelector(
    pageStructureState,
    (state: PageStructureState): GridsState => state[GRIDS_FEATURE_KEY]
);

export const selectAllGrids = createSelector(selectGridsState, (state: GridsState) => selectAll(state));

export const selectGridsEntities = createSelector(selectGridsState, (state: GridsState) => selectEntities(state));

export const selectGridsIds = createSelector(selectGridsState, (state: GridsState) => selectIds(state));

export const selectGridById = (id: Uuid) => createSelector(selectGridsEntities, (entities) => entities[id]);

export const selectDenormalizedGridEntityById = (id: Uuid) =>
    createSelector(selectGridsEntities, selectWidgetsEntities, (grids, widgets): DenormalizedGridEntity => {
        const normalizedGrid = {
            widgets: {
                ...widgets,
                ...grids,
            },
        };

        return denormalize(id, gridSchema, normalizedGrid);
    });
